<template>
  <span>
    <template v-if="value === 'ew001'">
      {{ $t('mobile_no') }}
      <v-modal-help>
        <div slot="body">
          <v-card-text>
            <h3 class="mb-2">คำแนะนำ การระบุเบอร์โทรศัพท์มือถือ</h3>
            <p>
              1.เข้าแอพลิเคชั่น ดอลฟิน
            </p>
            <p>2.เลือกหัวข้อ ดูโปรไฟล์</p>
            <p>
              3.จากนั้น นำ เบอร์โทรศัพท์มือถือ ที่ลงทะเบียนไว้ มาใส่ในช่องนี้
            </p>
            <v-layout row wrap>
              <v-flex xs12 md6 lg6 class="pa-2">
                <img src="/static/img/assets/verify_example/dolfin1.jpg" width="100%" alt />
              </v-flex>
              <v-flex xs12 md6 lg6 class="pa-2">
                <img src="/static/img/assets/verify_example/dolfin2.jpg" width="100%" alt />
              </v-flex>
            </v-layout>

            <div class="text-xs-center">
              <h3>ตัวอย่างสลิป Dolfin Wallet</h3>
              <img src="/static/img/assets/verify_example/dolfin.jpg" width="400px" alt />
            </div>
          </v-card-text>
        </div>
      </v-modal-help>
    </template>
    <template v-else-if="value === 'ew002'">
      {{ $t('mobile_no') }}
      <v-modal-help>
        <div slot="body">
          <v-card-text>
            <h3 class="mb-2">คำแนะนำ การระบุเบอร์โทรศัพท์มือถือ</h3>
            <p>
              1.เข้าแอพลิเคชั่น TrueMoney
            </p>
            <p>2.เลือกหัวข้อ ฉัน</p>
            <p>
              3.จากนั้น นำ เบอร์โทรศัพท์มือถือ ที่ลงทะเบียนไว้ มาใส่ในช่องนี้
            </p>
            <div class="text-xs-center">
              <img src="/static/img/assets/verify_example/true.jpg" width="400px" />
              <h3>ตัวอย่างสลิป TrueMoney</h3>

              <img src="/static/img/assets/verify_example/true_slip.jpg" width="400px" alt />
            </div>
          </v-card-text>
        </div>
      </v-modal-help>
    </template>
    <template v-else-if="value === 'ew003'">
      {{ $t('mobile_no') }}
      <v-modal-help>
        <div slot="body">
          <v-card-text>
            <h3 class="mb-2">คำแนะนำ การระบุเบอร์โทรศัพท์มือถือ</h3>
            <p>
              1.เข้าแอพลิเคชั่น Shopee
            </p>
            <p>2.เลือกสัญลักษณ์ <i class="fa fa-cog ml-1"></i></p>
            <p>
              3.เลือก บัญชีและความปลอดภัยของบัญชี
            </p>
            <p>4.จากนั้น นำ เบอร์โทรศัพท์มือถือ ที่ลงทะเบียนไว้ มาใส่ในช่องนี้</p>
            <v-layout row wrap>
              <v-flex xs12 md4 lg4 class="pa-2">
                <img src="/static/img/assets/verify_example/shopeepay1.png" width="100%" alt />
              </v-flex>
              <v-flex xs12 md4 lg4 class="pa-2">
                <img src="/static/img/assets/verify_example/shopeepay2.png" width="100%" alt />
              </v-flex>
              <v-flex xs12 md4 lg4 class="pa-2">
                <img src="/static/img/assets/verify_example/shopeepay3.png" width="100%" alt />
              </v-flex>
            </v-layout>
            <div class="text-xs-center">
              <h3>ตัวอย่างสลิป ShopeePay</h3>
              <img src="/static/img/assets/verify_example/shopeepay_slip.jpg" width="400px" alt />
            </div>
          </v-card-text>
        </div>
      </v-modal-help>
    </template>
    <template v-else-if="value === 'ew004'">
      {{ $t('reference_no') }}
      <v-modal-help>
        <div slot="body">
          <v-card-text>
            <h3 class="mb-2">คำแนะนำ การกรอกหมายเลขอ้างอิง (Ref.no)</h3>
            <p>
              1.เข้าแอพลิเคชั่น Line
            </p>
            <p>2.เลือกหัวข้อ Wallet</p>
            <p>
              3.เลือก Rabbit Line Pay
            </p>
            <p>4.จากนั้น นำ <strong>หมายเลขอ้างอิง (Ref.no)</strong> มาใส่ในช่องนี้</p>
            <v-layout row wrap>
              <v-flex xs12 md6 lg6 class="pa-2">
                <img src="/static/img/assets/verify_example/rabbit1.jpg" width="100%" alt />
              </v-flex>
              <v-flex xs12 md6 lg6 class="pa-2">
                <img src="/static/img/assets/verify_example/rabbit2.jpg" width="100%" alt />
              </v-flex>
            </v-layout>
            <div class="text-xs-center">
              <h3>ตัวอย่างสลิป Rabbit Line Pay</h3>
              <img src="/static/img/assets/verify_example/rabbit_slip.jpg" width="400px" alt />
            </div>
          </v-card-text>
        </div>
      </v-modal-help>
    </template>
    <template v-else-if="value === 'ew005'">
      {{ $t('ewallet_gwallet') }}
      <v-modal-help>
        <div slot="body">
          <v-card-text>
            <h3 class="mb-2">คำแนะนำ การกรอกหมายเลข G-Wallet</h3>
            <p>
              1.เข้าแอพลิเคชั่น เป๋าตัง
            </p>
            <p>2.เลือกหัวข้อ G Wallet → หน้าหลัก</p>

            <p>3.จากนั้น นำ <strong>หมายเลข G-Wallet </strong> มาใส่ในช่องนี้</p>
            <v-layout row wrap>
              <v-flex xs12 md6 lg6 class="pa-2">
                <img src="/static/img/assets/verify_example/gwallet1.jpg" width="100%" alt />
              </v-flex>
              <v-flex xs12 md6 lg6 class="pa-2">
                <img src="/static/img/assets/verify_example/gwallet2.jpg" width="100%" alt />
              </v-flex>
            </v-layout>
            <div class="text-xs-center">
              <h3>ตัวอย่างสลิป G-Wallet</h3>
              <img src="/static/img/assets/verify_example/gwallet_slip.jpg" width="400px" alt />
            </div>
          </v-card-text>
        </div>
      </v-modal-help>
    </template>
  </span>
</template>

<script>
export default {
  props: ['value']
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentPrefillVerifySlipFormExample.vue